import { render } from "./CozeChat.vue?vue&type=template&id=48d2ac60&scoped=true"
import script from "./CozeChat.vue?vue&type=script&lang=js"
export * from "./CozeChat.vue?vue&type=script&lang=js"

import "./CozeChat.vue?vue&type=style&index=0&id=48d2ac60&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d2ac60"]])

export default __exports__